import { Component } from '@angular/core';
import { TextHeaderComponent } from '../text-header/text-header.component';
import { TextComponent } from '../text/text.component';
@Component({
    selector: 'section-3',
    imports: [TextHeaderComponent, TextComponent],
    templateUrl: './section-3.component.html',
    styleUrls: ['../section.scss', './section-3.component.scss']
})
export class Section3Component {

}
